type ResourceTree = Record<string, unknown>;

/**
 * Materialise the configured en-US fallback in every locale resource bundle.
 * Localised leaves always win; newly introduced canonical keys remain present
 * until their translation is added.
 */
export function mergeLocaleResources<F extends ResourceTree, L extends ResourceTree>(
  fallback: F,
  localized: L
): F {
  const merged: ResourceTree = { ...fallback };
  for (const [key, value] of Object.entries(localized)) {
    const fallbackValue = merged[key];
    merged[key] =
      value &&
      fallbackValue &&
      typeof value === 'object' &&
      typeof fallbackValue === 'object' &&
      !Array.isArray(value) &&
      !Array.isArray(fallbackValue)
        ? mergeLocaleResources(fallbackValue as ResourceTree, value as ResourceTree)
        : value;
  }
  return merged as F;
}
